module.exports = __webpack_public_path__ + "img/block-375.e36cbba5.jpg";